import { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { BookingThemedRoot } from 'src/modules/booking/components/booking-themed-root'
import { ConfirmationWrapper } from 'src/modules/confirmation/containers'
import { LoadingWrapperContext } from 'src/modules/core/context'
import { useEventByUrlCode } from 'src/modules/event/hooks/use-event-by-url-code'

import classes from './confirmation.module.scss'

// Shares the wrapper's query key, so the branding costs no second request.
export const Confirmation = () => {
  const { disableLoading } = useContext(LoadingWrapperContext)
  const { urlCode } = useParams()
  const { data, isSuccess, isError } = useEventByUrlCode(urlCode)

  useEffect(() => {
    disableLoading()
  }, [disableLoading])

  return (
    <BookingThemedRoot
      theme={{ accentColor: data?.accent_color ?? null, isReady: !urlCode || isSuccess || isError }}
      className={classes.root}
    >
      <ConfirmationWrapper />
    </BookingThemedRoot>
  )
}
